/**
 * Cena za m² jako value object.
 *
 * Reguła domenowa: cena za m² jest prezentowana jako liczba całkowita złotych.
 * Surowa wartość z bazy (total_price / area_total) jest floatem (np. 13490.005)
 * i NIE może wyciec do prezentacji z miejscami po przecinku — zaokrąglenie
 * należy do domeny, nie do warstwy widoku/fielda.
 */
export class PricePerSquareMeter {
  /** Zaokrąglona wartość w złotych (liczba całkowita). */
  readonly value: number;
  readonly currency: string;

  /** Tekst zastępczy gdy cena nie jest znana. */
  static readonly UNKNOWN_LABEL = 'Nie podano';

  constructor(rawAmount: number, currency: string = 'PLN') {
    this.value = Math.round(rawAmount);
    this.currency = currency;
  }

  /** Czy cena jest znana (skończona liczba). */
  get isKnown(): boolean {
    return Number.isFinite(this.value);
  }

  /** Liczy cenę za m² z ceny całkowitej i powierzchni; null gdy brak powierzchni. */
  static fromTotalAndArea(
    totalAmount: number,
    areaTotal: number | null,
    currency: string = 'PLN',
  ): PricePerSquareMeter | null {
    if (!areaTotal || areaTotal <= 0) return null;
    return new PricePerSquareMeter(totalAmount / areaTotal, currency);
  }

  /** Format prezentacyjny "13 490 zł/m²" (zaokrąglony, pl-PL); "Nie podano" gdy brak ceny. */
  format(): string {
    if (!this.isKnown) return PricePerSquareMeter.UNKNOWN_LABEL;
    return `${this.value.toLocaleString('pl-PL')} zł/m²`;
  }
}
